import {
  Card,
  Text,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import type { TooltipProps } from 'recharts';
import styled from 'styled-components';

const StyledBox = styled(Card)`
  display: flex;
  flex-direction: column;
  max-width: 204px;
  text-align: center;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  padding: ${spacingHelper('medium extraLarge')};
`;

const HeaderText = styled(Text)`
  ${typographyHelper('overline')};
`;

const BodyContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacingHelper('extraSmall medium small medium')};
`;

const Title = styled(Text)<{ $boldHoverTitle?: boolean }>`
  font-weight: ${({ $boldHoverTitle }) => ($boldHoverTitle ? 'bold' : 'normal')};
`;

const ToolTipText = styled(Text)<{ $boldHoverTitle?: boolean }>`
  font-weight: ${({ $boldHoverTitle }) => ($boldHoverTitle ? 'normal' : 'bold')};
`;

interface GraphTooltipProps {
  label: string;
  title: string | null;
  subtitle: string;
  boldHoverTitle?: boolean;
}

export const GraphTooltip: FunctionComponent<GraphTooltipProps> = ({
  label,
  title,
  subtitle,
  boldHoverTitle = true,
}) => (
  <StyledBox>
    <HeaderContainer>
      <HeaderText variant="caption">{label}</HeaderText>
    </HeaderContainer>
    <BodyContainer>
      <BodyWrapper>
        <Title variant="body02" $boldHoverTitle={boldHoverTitle}>
          {title}
        </Title>
        <ToolTipText variant="caption" $boldHoverTitle={boldHoverTitle}>
          {subtitle}
        </ToolTipText>
      </BodyWrapper>
    </BodyContainer>
  </StyledBox>
);

export const TimeseriesAreaGraphTooltip: FunctionComponent<
  TooltipProps<number, string> & { boldHoverTitle?: boolean }
> = ({ active, payload, boldHoverTitle }) => {
  if (!active || !payload || !payload.length) return null;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const { label, title, subtitle } = payload[0].payload.hover as GraphTooltipProps;

  return (
    <GraphTooltip label={label} title={title} subtitle={subtitle} boldHoverTitle={boldHoverTitle} />
  );
};
